import React from 'react';
import { FONTS } from './theme';

const PaathshaalaFooter: React.FC = () => {
  return (
    <footer className="relative z-[1] text-center px-[26px] pt-9 pb-[110px]">
      <p
        className="text-sm uppercase tracking-[0.14em]"
        style={{ fontFamily: FONTS.body, color: 'rgba(93,64,55,0.7)' }}
      >
        A{' '}
        <a
          href="/"
          className="underline underline-offset-2 transition-opacity hover:opacity-80"
        >
          Vidya.ai
        </a>{' '}
        experience &middot; &copy; {new Date().getFullYear()}
      </p>
    </footer>
  );
};

export default PaathshaalaFooter;
